import React, { forwardRef } from 'react';
import { Text } from '../typography';
export const Checkbox = forwardRef(({ id, label, checked, onChange, disabled, className }, ref) => {
    return (React.createElement("label", { className: `cb-checkbox-input-field${className ? ` ${className}` : ''}` },
        React.createElement(Text, { level: '2', textColorVariant: 'secondary' }, label),
        React.createElement("input", { type: 'checkbox', id: id, checked: checked, onChange: onChange, disabled: disabled, ref: ref }),
        React.createElement("span", { className: 'cb-checkbox-input' })));
});
export default Checkbox;
